export default __webpack_public_path__ + "static/media/edit_customisable_items.fc178518.png";